import * as React from "react";
import type { SVGProps } from "react";
const SvgIconWaterTap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 1.62c-.33.07-.58.33-.64.67-.04.2-.04 19.22 0 19.42.07.36.33.62.7.68.1.02 1.13.02 3.43.02H9l.15-.07q.38-.19.48-.56c.03-.1.03-.74.03-3.43 0-3.63 0-3.55.14-3.95.27-.72.84-1.25 1.6-1.47l.2-.05 5.06-.02c4.63 0 5.07-.01 5.16-.05.2-.08.4-.25.5-.44.08-.17.09-.34.08-2.46 0-2.28 0-2.16-.15-2.38-.09-.12-.28-.27-.42-.32-.1-.04-.43-.05-6.14-.05l-6.03-.01V3.31h3.96c2.74 0 4 0 4.1-.03q.42-.08.63-.5c.05-.1.06-.16.06-.33s-.01-.23-.06-.34q-.15-.3-.43-.44l-.16-.08h-7.69c-5.9 0-7.72 0-7.83.03m1.06 3.61v1.92h4.66V3.31H3.3zm0 9.55v5.9h4.66v-2.93c0-2.8 0-2.95.04-3.21.28-1.6 1.43-2.86 2.97-3.26.5-.14.2-.13 5.14-.14h4.57V8.87H3.3zm15.62-.42c-.24.07-.39.2-.96.9-1.07 1.32-1.75 2.48-1.98 3.35-.05.23-.06.3-.06.58 0 .38.05.68.17 1.02q.32.98 1.2 1.61.82.57 1.86.58 1.35 0 2.3-.95c.61-.61.93-1.4.94-2.26 0-.26 0-.36-.06-.57q-.26-1.03-1.38-2.58c-.53-.7-1.15-1.45-1.32-1.57-.2-.14-.46-.18-.7-.11m.04 2.41c-.6.8-1.1 1.62-1.27 2.1-.2.62.17 1.38.83 1.68.4.19.87.19 1.27 0 .53-.24.89-.79.89-1.35 0-.32-.23-.81-.72-1.56-.23-.35-.72-1.03-.78-1.08-.03-.02-.07.01-.22.21"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconWaterTap;
